module.exports = __webpack_public_path__ + "static/media/ConnexionScreen_state2_elImage_1280929045.3cde049e.png";